import { Pipe, PipeTransform } from "@angular/core";
import { environment } from "src/environments/environment";

@Pipe({name: 'storagePrefix'})
export class StoragePrefixPipe implements PipeTransform {

  constructor() {}

  transform(value: string | undefined) {
    if (!value) { return; }
    return environment.blobStorageUrl + value;
  }
}
